var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.25H8.75V5C8.75 4.33696 9.01339 3.70107 9.48223 3.23223C9.95107 2.76339 10.587 2.5 11.25 2.5H18.75C19.413 2.5 20.0489 2.76339 20.5178 3.23223C20.9866 3.70107 21.25 4.33696 21.25 5V6.25H25C25.3315 6.25 25.6495 6.3817 25.8839 6.61612C26.1183 6.85054 26.25 7.16848 26.25 7.5C26.25 7.83152 26.1183 8.14946 25.8839 8.38388C25.6495 8.6183 25.3315 8.75 25 8.75H23.75V25C23.75 25.663 23.4866 26.2989 23.0178 26.7678C22.5489 27.2366 21.913 27.5 21.25 27.5H8.75C8.08696 27.5 7.45107 27.2366 6.98223 26.7678C6.51339 26.2989 6.25 25.663 6.25 25V8.75H5C4.66848 8.75 4.35054 8.6183 4.11612 8.38388C3.8817 8.14946 3.75 7.83152 3.75 7.5C3.75 7.16848 3.8817 6.85054 4.11612 6.61612C4.35054 6.3817 4.66848 6.25 5 6.25ZM8.75 8.75V25H21.25V8.75H8.75ZM11.25 6.25H18.75V5H11.25V6.25ZM11.25 11.25H13.75V22.5H11.25V11.25ZM16.25 11.25H18.75V22.5H16.25V11.25Z",
    fill: "#FF3131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9dd7389904d8db52cbc81643a9b54cf7.svg";
export { ForwardRef as ReactComponent };